<ng-container *transloco="let t">
  <div class="customer-name">
    {{ name() || 'Sin nombre' }}
  </div>
  @if (phone()) {
    <a href="tel:{{ phone() }}" class="customer-phone">{{ phone() }}</a>
  } @else if (showMissingPhone()) {
    <span class="customer-phone">Sin teléfono</span>
  }
  @if (phone() && whatsappButtonEnabled()) {
    <a
      class="customer-whatsapp"
      [href]="whatsappLink()"
      [target]="whatsappTarget"
      (click)="onWhatsappClick()"
    >
      <pxw-icon icon="whatsapp"></pxw-icon>
    </a>
  }
</ng-container>
